import { getConsentForCategory } from '../utils/cookie-consent-helpers';
import type { TrackingConsent, DatadogRum } from '@datadog/browser-rum';

/**
 * Get tracking consent status using cookie consent helpers.
 * Returns 'granted' if user has consented to performance tracking.
 */
export function getTrackingConsent(): TrackingConsent {
  try {
    const hasPerformanceConsent = getConsentForCategory('performance');
    return hasPerformanceConsent ? 'granted' : 'not-granted';
  } catch {
    return 'not-granted';
  }
}

/**
 * Clears Datadog session cookie by expiring it.
 */
function clearDatadogSessionCookie(): void {
  if (typeof document === 'undefined') return;

  // Expire the _dd_s session cookie
  document.cookie = '_dd_s=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
}

export const updateConsentValues = (ddRum: DatadogRum) => {
  const hasPerformanceConsent = getConsentForCategory('performance');
  ddRum.setTrackingConsent(hasPerformanceConsent ? 'granted' : 'not-granted');

  // Also manually expire the session cookie when revoking consent
  if (!hasPerformanceConsent) {
    clearDatadogSessionCookie();
  }
};
